import { StackProps, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionVStack = motion<StackProps>(VStack);

export default MotionVStack;